
export default function(){
    
    const initialState = {
        loading: false,
        message: null,
        loads: 0
    }
    

    return function(state = initialState, action) {

        switch(action.type){

            //
            case "SHOW_LOADING": return {
                ...state,
                loading: true,
                loads: state.loads + 1
            }

            //
            case "HIDE_LOADING": return {
                ...state,
                loading: false
            }

            //
            case "SHOW_MESSAGE": return {
                ...state,
                message:action.message
            }

            //
            case "HIDE_MESSAGE": return {
                ...state,
                message: null
            }

            //
            default: return state;

        }

    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/status/status-reducer.ts